// extracted by mini-css-extract-plugin
module.exports = {"OrderSession":"OrderSession_OrderSession_3ch6k","courseSession":"OrderSession_courseSession_QyS1D"};